module.exports = __webpack_public_path__ + "static/media/profile.68b2f9bb.jpg";